import { Container, dispatcher, EventConstants, ingenuity, SpineBase, IEvent } from "@quest/base-core";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
import {
  FreeGameViewBehavior,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  SoundConstant,
} from "@quest/murka-games-behavior-panther/dist";
import { ReelPanel, SlotConstants } from "@quest/slot-core";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { GameParserModel } from "../Platform/GameParserModel";

export class FreeGameView extends FreeGameViewBehavior {
  protected initializeComponents(): void {
    super.initializeComponents();
  }
  /**
   * Method overrided to add reel glow at 0
   */
  setReelView(reelView: ReelPanel, pos?: number, parentId?: string): void {
    this.reelView = reelView;
    this.addChildAt(this.getSpineById("freegame_reel_bg_glow"), 0);
    this.addChildAt(this.getImageById("reelBGFg"), 1);
    this.addChildAt(reelView, 2);
    const container = this.getContainerByID("reelsContainerFg");
    this.addChildAt(container, 3);
    if (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT) {
      this.reelView.x = this.reelView.json.portraitX;
      this.reelView.y = this.reelView.json.portraitY;
    }
    this.resize(new Event(EventConstants.RESIZE, ingenuity.deviceEnv.update()));
  }

  /**
   * function is over rided to play spine animation for anticipation
   * the animation name is changed in given spine
   */
  showAnticipation(reel: number, callback?: () => void, callbackScope?: any): void {
    if (typeof this.anticipationContainer === "undefined") {
      this.anticipationContainer = new Container(this.json, this.game);
      this.anticipationContainer.name = SlotConstants.AnticipationConatiner;
      this.addChild(this.anticipationContainer);
    }
    if (this.json.anticipationAnim) {
      const anticJson = this.json.anticipationAnim;
      anticJson.id = "anticipation";
      anticJson.type = "spine";
      const anticipation = this.createSpine(anticJson);
      if (anticipation) {
        anticipation.visible = true;
        this.anticipationContainer.addChild(anticipation);
        this.anticipationContainer.x = this.json.reels.reels[reel].x + this.json.reels.x + this.json.anticipationAnim.valueX;
        this.anticipationContainer.y = this.json.reels.reels[reel].y + this.json.reels.y + this.json.anticipationAnim.valueY;
        this.addChild(this.anticipationContainer);
        anticipation.playAnim("in");
        anticipation.onComplete.addOnce(() => {
          anticipation.playAnim("loop", true);
        });
      }
    }
  }

  /**
   * overrided to avoid symbol fade as per game
   */
  protected showAlpha(): void {
    //
  }
  // Override to play landing animation
  landingAnimation(data: any, callback?: () => void, callbackScope?: any): void {
    const reelgrid = data[0];
    const reelview = data[1];
    const reelId = data[2];
    for (let i = 0; i < reelgrid[reelId].length; i++) {
      if (this.json.reels.symbolData[reelgrid[reelId][i]].hasLanding) {
        const symbol = reelview.getSymbolByPos(reelId, i);
        const staticSym = symbol.getStatic();
        const animSym: SpineBase = symbol.getAnimation() as SpineBase;
        if (animSym) {
          const staticSymParent = staticSym.parent;
          if (staticSymParent) {
            staticSym.visible = false;
            animSym.visible = true;
            staticSymParent.addChild(animSym);
            animSym.playAnim("static", false, 0);
            animSym.onComplete.addOnce(() => {
              animSym.playAnim("landing", false);
              const symId = reelgrid[reelId][i];
              if (gameConstants.SYMBOL_WILD === symId) {
                this.playWildSound([reelId, i]);
              }
            }, this);
          }
        }
      }
    }
  }
  /**
   * play wild landing sound when wild on reel
   * @param position 
   */
  private playWildSound(position: number[]): void {
    let stickyData = (ingenuity.parserModel as GameParserModel).getCollectWildData().wildPos;
    let ifExist = stickyData.some(
      (arr: any) => arr.length === position.length && arr.every((val: number, index: number) => val === position[index])
    );
    if (ifExist) {
      (ingenuity.soundManager as any).playSound(
        SoundConstantGame.WILD_DROP_SOUND_FREEGAME,
        1,
        false,
        SlotConstantsBehavior.SOUND_LIST_PRELOAD
      );
    }
  }

  // Overrided to play fs symbols landing sounds
  protected checkAndPlayLandingSounds(evt: IEvent): void {
    const scatterSoundId = SoundConstant.SCATTER_LANDING;
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: scatterSoundId + evt.data.symbolCount, vol: 1, loop: false });
  }
}
